/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationUserResponse } from '../../models/organization-user-response';

export interface OrganizationMembersGet$Json$Params {
}

export function organizationMembersGet$Json(http: HttpClient, rootUrl: string, params?: OrganizationMembersGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OrganizationUserResponse>>> {
  const rb = new RequestBuilder(rootUrl, organizationMembersGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OrganizationUserResponse>>;
    })
  );
}

organizationMembersGet$Json.PATH = '/organization/members';
